import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { CITY } from '../../fields';
import { CITY_VIDEO_REPORT_ID } from './cityVideoReportId';

const cityReportFooterColumnDefinition = [CITY].map(createFooterMapper(CITY_VIDEO_REPORT_ID));

export default cityReportFooterColumnDefinition;
